import React from 'react';
import AuthActions from '../actions/AuthActions';

export default class Logout extends React.Component {
  componentDidMount() {
    this.doLogout();
  }

  doLogout() {
    AuthActions.logout();
  }

  render() {
    return (<p>Logged Out</p>);
  }
}
